<template>
<div class="general-container">
    <section>
        <div>
            <slot></slot>
        </div>
    </section>
</div>
</template>

<script>

export default {

	name: "GeneralContainer",

}

</script>
